import { useState } from 'react'

type ImagePreviewProps = {
  name: string
  url: string
  width: number
  height: number
  emptyPlaceholder?: 'plus' | 'minus'
}

export function ImagePreview({
  url,
  name,
  width,
  height,
  emptyPlaceholder = 'plus',
}: ImagePreviewProps) {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div
      className='relative'
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {url ? (
        <img
          src={url}
          alt={name}
          style={{ width, height }}
          className='object-cover cursor-pointer'
        />
      ) : (
        <span
          className={
            emptyPlaceholder === 'minus'
              ? 'text-gray-500 cursor-pointer'
              : 'text-blue-600 cursor-pointer'
          }
        >
          {emptyPlaceholder === 'minus' ? '-' : '+'}
        </span>
      )}

      {isHovered && url && (
        <div className='absolute w-[200px] h-[200px] z-50 right-[50px] bottom-0'>
          <img
            src={url}
            alt={name}
            className='object-contain rounded'
            style={{ height: '200px' }}
          />
        </div>
      )}
    </div>
  )
}
